/* eslint-disable */
/* tslint:disable */
export {default as pause} from './components/pause.js';
export {default as play_background} from './components/play_background.js';
export {default as play_triangle} from './components/play_triangle.js';
export {default as rotate_arrow} from './components/rotate_arrow.js';
export {default as play} from './components/play.js';
export {default as x} from './components/x.js';
export {default as ARROWS_DATA } from './arrowsIconsData.js';
/* tslint:enable */
/* eslint-enable */
